import React, { useEffect, useState } from 'react'
import MaterialTable from '@material-table/core'
import { getUsers } from '../../services/users/getUsers'
import { PersonAdd, ToggleOff, ToggleOn } from '@material-ui/icons'
import NewUserDialog from './NewUserDialog'
export default function UsersManagementTable() {
  const [users, setUsers] = useState([])
  const [openDialog, setOpenDialog] = useState(false)

  const handleClickOpen = () => {
    setOpenDialog(true)
  };

  const handleClose = () => {
    setOpenDialog(false)
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getUsers()
        setUsers(data.filter(element => !element.email.includes(localStorage.getItem('dashboard_logged_user'))))
      } catch (error) {
        console.log(error)
        alert('Error al traer los usuarios')
      }
    }
    fetchUsers()
    return () => {
      
    }
  }, [])
  return (
    <>
      <NewUserDialog open={openDialog} handleClose={handleClose} />
      <MaterialTable
        columns={[
          { 
            title: "id", 
            field: "id", 
            type: "string",
            hidden: true,
            editable: false,
            searchable: false,
          },
          { 
            title: "Nombre de Usuario", 
            field: "email", 
            type: "string",
            width: "100%",
            editable: false,
            searchable: true,
          },
        ]}
        title={'Gestión de usuarios'}
        options={{
          actionsColumnIndex: -1,
          pageSize: 50,
          emptyRowsWhenPaging: false,
          search: true,
          paging: true,
          sorting: false,
          rowStyle: { fontFamily: "Roboto" },
        }}
        data={users}
        // editable={{
        //   onRowUpdate: (newData, oldData) =>
        //     updateUser({id: newData.id, profile: newData.profile}).then((result) => {
        //       setUsers([...users.map(element => element.id === result.id ? result : element)])
        //     }).catch((err) => {
        //   }),
        // }}
        actions={[
          {
            name: "addUser",
            tooltip: 'Crear usuario',
            icon: () => <PersonAdd />,
            onClick: (evt, data) => {
              (async function() {
                handleClickOpen()
              })();
            },
            isFreeAction: true,            
          },
          // rowData => ({
          //   name: "disabledUser",
          //   tooltip: 'Activar/Desactivar usuario',
          //   icon: () => rowData.is_active ? <ToggleOn style={{color: 'green'}} /> : <ToggleOff style={{color: 'red'}} />,
          //   onClick: (evt, data) => {
          //     (async function() {
          //       const user = await switchEnabledUser({id: data.id})
          //       setUsers([...users.map(element => element.id === user.id ? user : element)])
          //     })();
          //   }
          // }),
        ]}
        localization={{
          toolbar: {
              nRowsSelected: '{0} registro(s) seleccionado(s)',
              searchPlaceholder: 'Buscar',
              searchTooltip: 'Buscar'
          },
          header: {
              actions: 'Acciones'
          },
          body: {
              emptyDataSourceMessage: 'No hay usuarios',
              filterRow: {
                  filterTooltip: 'Filtro'
              },
              editRow: {
                deleteText: '¿Seguro que desea desactivar el usuario?'
            }
          },
          pagination: {
            labelRowsSelect: 'usuarios',
            labelDisplayedRows: '{from}-{to} de {count}',
            firstTooltip: 'Primera página',
            previousTooltip: 'Anterior',
            nextTooltip: 'Siguiente',
            lastTooltip: 'Última página'
          }
        }}
      />
    </>
  );
}
